import { NgModule } from '@angular/core';

import { FeaturesRoutingModule } from './features.routing.module';
import { FEATURE_NAME, reducers as featuresReducers } from "./store/features.state";
import { EffectsModule } from "@ngrx/effects";
import { ChacrasEffects } from "./store/entities/shared/chacras/chacras.effects";
import { ChacrasGeoEffects } from "./store/entities/shared/chacras-geo/chacras-geo.effects";
import { PersonasEffects } from "./store/entities/shared/personas/personas.effects";
import { EmpresasEffects } from "./store/entities/shared/empresas/empresas.effects";
import { IngenierosAgronomosEffects } from "./store/entities/shared/ingenieros-agronomos/ingenieros-agronomos.effects";
import { DibujosEffects } from "./store/entities/shared/dibujos/dibujos.effects";
import { AdjuntosEffects } from "./store/entities/shared/adjuntos/adjuntos.effects";
import { MensajesEffects } from "./store/entities/shared/mensajes/mensajes.effects";
import { SuelosEffects } from "./store/entities/shared/suelos/suelos.effects";
import { CultivosEffects } from "./store/entities/shared/cultivos/cultivos.effects";
import { RolesEffects } from "./store/entities/shared/roles/roles.effects";
import { RolesArcgisEffects } from "./store/entities/shared/roles-arcgis/roles-arcgis.effects";
import { StoreModule } from "@ngrx/store";
import { MainComponent } from './components/main/main.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations:[MainComponent],
  imports: [
    FeaturesRoutingModule,
    StoreModule.forFeature(FEATURE_NAME, featuresReducers),
    EffectsModule.forFeature([
      ChacrasEffects,
      ChacrasGeoEffects,
      PersonasEffects,
      EmpresasEffects,
      IngenierosAgronomosEffects,
      DibujosEffects,
      AdjuntosEffects,
      MensajesEffects,
      SuelosEffects,
      CultivosEffects,
      RolesEffects,
      RolesArcgisEffects,
    ]),
    SharedModule
  ],
  exports: [
    MainComponent,
  ],
  providers: [
  ]
})
export class FeaturesModule { }
